import PropTypes from 'prop-types';
import { Card, CardContent } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import ReadOnlyTextField from 'src/components/widgets/readonly-textfield';

export const RepairView = ({ item, services = []}) => {
  return (
    <Card>
      <CardContent sx={{ px: 1, py: 2 }}>
        <Grid container spacing={5}>
          <Grid xs={12} md={3}>
            <><Grid container spacing={3}>
                <Grid xs={12} md={12}>
                  <ReadOnlyTextField label="Biển số" value={item.plate} />
                </Grid>
                <Grid xs={12} md={12}>
                  <ReadOnlyTextField label="ODO" value={item.lastKm} />
                </Grid>
              </Grid>
            </>
          </Grid>
          <Grid xs={12} md={9}>
            <><Grid container spacing={3}>
              {services.map((entry, index) => (
                <Grid key={index} xs={12} md={3}>
                  <ReadOnlyTextField 
                    label={entry.label} value={entry.value}
                    enumType="decimal" sx={{ "& .MuiInputBase-input": { color: `${entry.color}` } }} />
                </Grid>
              ))}
              </Grid>
            </>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

RepairView.propTypes = {
  item: PropTypes.object.isRequired,
  services: PropTypes.array,
};